// extracted by mini-css-extract-plugin
export default {"gradient":"TableSkeleton_gradient__HZwUC","shine-lines":"TableSkeleton_shine-lines__yQNhg"};